import {UserId} from './user';
import {Tile} from './tile';
import {Device} from './device';
import {Hub} from './hub';
import { App } from './app';

export type ObjectId = string;

export enum ObjectType {
  APP = 'app',
  DEVICE = 'device',
  HUB = 'hub',
  TILE = 'tile',
  USER = 'user'
}

export type ObjectModelKeyMap = { [objectKey: ObjectKey]: ObjectModel };

export class ObjectModel {
  id: ObjectId;
  type: ObjectType;
  name: string;
  owner: UserId;


  constructor(obj?: {
    id?: ObjectId,
    type?: ObjectType,
    name?: string,
    owner?: UserId,
  }) {
    if (obj) {
      this.id = obj.id;
      this.type = obj.type;
      this.name = obj.name;
      this.owner = obj.owner;
    }
  }


  toKey(): ObjectKey {
    return makeObjectKey(this.type, this.id);
  }


  static fromKey(key: ObjectKey): ObjectModel {
    const parts = key.split('.');

    const object = new ObjectModel();
    object.type = <ObjectType>parts[0];
    object.id = parts[1];

    return object;
  }


  static fromTile(tile: Tile): ObjectModel {
    return new ObjectModel({
      id: tile.ID,
      type: ObjectType.TILE,
      name: tile.Name,
      owner: tile.Owner,
    });
  }


  static fromDevice(device: Device): ObjectModel {
    return new ObjectModel({
      id: device.ID,
      type: ObjectType.DEVICE,
      name: device.Name,
      owner: device.Owner,
    });
  }


  static fromHub(hub: Hub): ObjectModel {
    return new ObjectModel({
      id: hub.ID,
      type: ObjectType.HUB,
      name: hub.Name,
      owner: hub.Owner,
    });
  }

  static fromApp(app: App): ObjectModel {
    return new ObjectModel({
      id: app.ID,
      type: ObjectType.APP,
      name: app.Name,
      owner: app.Owner,
    });
  }
}

export function makeObjectKey(type: ObjectType, id: ObjectId): ObjectKey {
  return `${type}.${id}`;
}

export type ObjectKey = string;
